<nav class="navbar navbar-expand-lg nav-crev" [class.nav-scroll]="isSticky()">
  <div class="container">
    <a class="navbar-brand logo-stack" [href]="homeHref()" (click)="goHome($event)">
      <img class="logo logo--white" src="assets/images/brand/logo-white.svg" alt="DrivOn" width="199" height="64" />
      <img class="logo logo--black" src="assets/images/brand/logo-black.svg" alt="" aria-hidden="true" width="199" height="64" />
    </a>
    <button
      class="navbar-toggler ms-auto"
      type="button"
      (click)="isCollapsed = !isCollapsed"
      aria-controls="navbarNavAltMarkup"
      [attr.aria-expanded]="!isCollapsed"
      aria-label="Toggle navigation"
    >
      <span class="icon-bar"
        ><i class="icofont icofont-navigation-menu" aria-hidden="true"></i
      ></span>
    </button>
    <div
      class="collapse navbar-collapse"
      [ngClass]="{ collapse: isCollapsed, 'navbar-collapse': true }"
      id="navbarNavAltMarkup"
    >
      <ul
        class="navbar-nav navbar-center xs-mt-20"
        style="
          display: flex;
          flex: 1;
          justify-content: center;
          align-items: center;
        "
      >
        <li class="nav-item" style="--i: 0">
          <a
            class="nav-link"
            data-section="home"
            [href]="sectionHref('home')"
            (click)="scrollToSection('home', $event)"
            >{{ "navbar.home" | translate }}</a
          >
        </li>
        <li class="nav-item" style="--i: 1">
          <a
            class="nav-link"
            data-section="about"
            [href]="sectionHref('about')"
            (click)="scrollToSection('about', $event)"
            >{{ "navbar.about" | translate }}</a
          >
        </li>
        <li class="nav-item" style="--i: 2">
          <a
            class="nav-link"
            data-section="services"
            [href]="sectionHref('services')"
            (click)="scrollToSection('services', $event)"
            >{{ "navbar.services" | translate }}</a
          >
        </li>
        <li class="nav-item" style="--i: 3">
          <a
            class="nav-link"
            data-section="features"
            [href]="sectionHref('features')"
            (click)="scrollToSection('features', $event)"
            >{{ "navbar.features" | translate }}</a
          >
        </li>
        <li class="nav-item" style="--i: 4">
          <a
            class="nav-link"
            [routerLink]="buildLink('/quiz')"
            routerLinkActive="is-active"
            ariaCurrentWhenActive="page"
            (click)="isCollapsed = true"
            >{{ "navbar.quiz_list" | translate }}</a
          >
        </li>
        <li class="nav-item" style="--i: 5">
          <a
            class="nav-link"
            data-section="contact"
            [href]="sectionHref('contact')"
            (click)="scrollToSection('contact', $event)"
            >{{ "navbar.contact" | translate }}</a
          >
        </li>
      </ul>
      <div class="nav-button ms-auto xs-ml-0">
        <ul
          class="nav navbar-nav navbar-right"
          style="
            display: flex;
            justify-content: center;
            margin-right: 30px;
            align-items: center;
          "
        >
          <li class="nav-item" style="--i: 6">
            <div class="lang-switch" role="radiogroup" aria-label="Language / Լեզու / Язык">
              <button
                *ngFor="let language of languages; let i = index"
                type="button"
                role="radio"
                class="lang-switch__btn"
                [attr.data-lang]="language.code"
                [attr.lang]="language.code === 'am' ? 'hy' : language.code"
                [attr.aria-checked]="selectedLanguage === language.code"
                [attr.aria-label]="language.name"
                [attr.tabindex]="selectedLanguage === language.code ? 0 : -1"
                [class.is-active]="selectedLanguage === language.code"
                (click)="selectLanguage(language.code)"
                (keydown)="onLanguageKeydown($event, i)"
              >
                {{ language.short }}
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="nav-progress" aria-hidden="true"><span class="nav-progress__fill"></span></div>
</nav>
